import { initSplitApi } from './init'
import * as q from './elastic-query'

export const usTiresApi = initSplitApi.injectEndpoints({
    reducerPath: 'ustires',
    endpoints: (builder) => ({

        usTriesEdit: builder.mutation({
            query: (body) => {
                return {
                    url: `tires/_update/${body.doc.id}`,
                    method: 'POST',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['usTiresList']
        }),
        usTiresList: builder.query({
            query: (params) => ({
                url:`tires/_search`,
                method: 'POST',
                body: q.getList(params.criteria),
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if(response?.hits?.hits?.length>0){
                    var r = response;
                    return r
                }
            },
            providesTags: ['usTiresList']
        }),
        getAppDetails: builder.query({
            query: (params) => ({
                url:"",
                method: "",
                service: 'app',
                params: params
            }),
            transformResponse: (response, meta, arg) => {
                console.log(response);
                return response;
            },
            providesTags: ['usTiresList']
        }),
        getLogs: builder.query({
            query: (params) => ({
                url:"",
                method: "",
                service: 'logs',
                params: params
            }),
            transformResponse: (response, meta, arg) => {
                console.log(response);
                return response;
            },
            providesTags: ['usTiresList']
        }),
        nhtsaDetails: builder.query({
            query: (params) => ({
                method: 'GET',
                service: 'nhtsa',
                params: params
            }),
            transformResponse: (response, meta, arg) => {
                var recallsCount = 0;
                var complaintsCount = 0;
                var investigationsCount = 0;
                var manufacturerCommunicationsCount = 0;
                response.results.map(r=>{
                    recallsCount = recallsCount + r.recallsCount;
                    complaintsCount = complaintsCount + r.complaintsCount;
                    investigationsCount = investigationsCount + r.investigationsCount;
                    manufacturerCommunicationsCount = manufacturerCommunicationsCount + r.manufacturerCommunicationsCount;
                })
                var res = {
                    meta: response.meta || {},
                    modelCount: response.results?.length || 0,
                    results: response.results || [],
                    recallsCount: recallsCount,
                    complaintsCount: complaintsCount,
                    investigationsCount: investigationsCount,
                    manufacturerCommunicationsCount: manufacturerCommunicationsCount
                }
                return res;
            },
            providesTags: ['nhtsaDetails']
        }),
        usTiresDetails: builder.query({
            query: (params) => ({
                url:`tires/_search`,
                method: 'POST',
                body: q.getDetailsUsTires(params.id),
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if(response?.hits?.hits?.length>0){
                    return response.hits.hits[0]._source;
                }
            },
            providesTags: ['usTiresList']
        }),
    }),

    overrideExisting: false
})

export const { 
    useUsTiresCreateMutation,
    useUsTiresDeleteMutation,
    useUsTiresEditMutation,
    useUsTiresDetailsQuery,
    useNhtsaDetailsQuery,
    useGetAppDetailsQuery,
    useUsTiresListQuery,
    useGetLogsQuery
} = usTiresApi